export type TrackingValue = string | number | boolean | null | undefined;

export const toStr = (value: TrackingValue): string | undefined => {
    if (value === null || value === undefined || value === '') {
        return undefined;
    }
    return String(value);
};

export const toRequiredStr = (value: TrackingValue, fallback = ''): string =>
    toStr(value) ?? fallback;

export const toNumericStr = (value: TrackingValue): string =>
    (toStr(value) ?? '').replace(/\D/g, '');

export const compact = <T extends object>(obj: T): T =>
    Object.fromEntries(Object.entries(obj).filter(([, value]) => value !== undefined)) as T;

const toLowestCategory = (value: TrackingValue): string => {
    const category = toStr(value);
    if (!category) {
        return '';
    }
    const segments = category.split('/').filter(Boolean);
    return segments[segments.length - 1] || '';
};

export const resolveProductCategory = (product: { category?: TrackingValue }): string | undefined =>
    toStr(product.category);

export const getCategory = (product: { category?: TrackingValue }): string =>
    toLowestCategory(product.category);
